import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function Open({ symbol_id }) {
  const socket = useContext(SocketContext);

  const [open, setOpen] = useState(0);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.Open !== undefined) {
        setOpen(data.Open);
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return (
    <div className="menuOpen">
      <CheckValue number={open} />
    </div>
  );
}
